
export enum MemberType {
  visitor = 'visitor',
  companyMember = 'company-member',
  superAdmin = 'super-admin',
}

export interface IUserData {
  email: string;
  id: string;
  memberType: MemberType;
  mobilePhone: string;
  name: string;
  phone: string;
  role: string;
  chatAuthToken: string;
  language: string;
  avatarUrl?: string;
  companyId?: string;
}
